<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('material.fiveBitCode')" prop="fiveBitCode">
                    <el-input v-model.trim="queryCondition.fiveBitCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('material.eightBitCode')" prop="eightBitCodeStr" class="iconStyle">
                    <el-input v-model="queryCondition.eightBitCodeStr" clearable type="textarea" :autosize="{maxRows:1}" style="width:100%"></el-input>
                    <i class="el-icon-menu" @click="menuClick"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('material.eightBitCodeName')" prop="eightBitCodeName">
                    <el-input v-model="queryCondition.eightBitCodeName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工厂名称" prop="tmPlantName">
                    <el-input v-model.trim="queryCondition.tmPlantName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="工厂编码" prop="tmPlantCode">
                      <el-input v-model="queryCondition.tmPlantCode" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="结算单位名称" prop="settlementUnitName">
                      <el-input v-model.trim="queryCondition.settlementUnitName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category1" prop="categoryLevel1Id">
                      <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category2" prop="categoryLevel2Id">
                      <el-select v-model="queryCondition.categoryLevel2Id" clearable @change="changeCategory2()" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="Category3" prop="categoryLevel3Id">
                      <el-select v-model="queryCondition.categoryLevel3Id" clearable style="width:100%">
                        <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.tmCategoryId"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('material.status')" prop="status">
                      <el-select v-model="queryCondition.status" clearable style="width:100%">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="startCreateDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.startCreateDate" type="date" :picker-options="pickerOptionsStart" style="width:100%" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="endCreateDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.endCreateDate" type="date" :picker-options="pickerOptionsEnd" style="width:100%" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="conductStatus">
                      <el-select v-model="queryCondition.conductStatus" clearable style="width:100%">
                        <el-option :key="index" v-for="(item,index) in conductStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" v-if='emplFlag != "SUP"'>
                    <!--除了供应商以外的-->
                    <el-form-item :label="$t('material.isConventionalMaterial')" prop="isUrgentMaterial">
                      <!--是否为紧急创建物料-->
                      <ic-select table="TM_MATERIAL_RECORD" field="IS_NOT" clearable v-model="queryCondition.isUrgentMaterial" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-dropdown split-button type="primary" @click="handleClick" placement="bottom" v-if="emplFlag == 'S'||emplFlag == 'M'">
          新增
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <!-- 新增 -->
              <el-button size="mini" class="dropdownItemBtn" v-if="emplFlag == 'S'||emplFlag == 'M'" type="primary" @click="goAdd('add')">{{$t('material.add')}}</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!-- 新增玩具物料 -->
              <el-button size="mini" class="dropdownItemBtn" v-if="emplFlag == 'M'" type="primary" @click="goAdd('add','','new_toy_material')"> {{$t('material.primary')}}</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!-- 新增非常规物料 -->
              <el-button size="mini" class="dropdownItemBtn" v-acl="addition_of_unconventional_materials" v-if="emplFlag == 'M'" type="primary" @click="goAdd('conven','','new_unconventional_materials')">{{$t('material.new_unconventional_materials')}} </el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!-- 新增紧急物料 -->
              <el-button size="mini" class="dropdownItemBtn" v-if="emplFlag == 'M'" type="primary" @click="goAdd('add','','new_conventional_material')"> {{$t('material.new_conventional_material')}} </el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 删除 -->
        <el-button class="btn" size="mini" v-acl="material_delete" type="danger" @click="deleteRow">{{$t('common.del')}}</el-button>
        <!-- 撤回 -->
        <el-button class="btn" size="mini" type="primary" v-if="isRecall" @click="onWithdraw">撤回</el-button>
        <!-- 复制创建 -->
        <el-button class="btn" size="mini" v-acl="material_information_copy" type="primary" @click="copy">{{$t('material.material_information_copy')}}</el-button>
        <!-- 模板下载 -->
        <el-button class="btn" size="mini" v-if="emplFlag == 'S'||emplFlag == 'M'" type="primary" @click="downLoadTemplate">模板下载</el-button>
        <!-- 批量导入 -->
        <el-upload style="margin-right:10px;vertical-align: middle;line-height: 0;" v-if="emplFlag == 'S'||emplFlag == 'M'" :show-file-list="false" ref="upload" :before-upload="beforeUpload" :headers="uploadHeader" :action="fileUploadUrl" :on-success="uploadSuccess" :on-error="uploadError" multiple>
          <el-button type="primary" size="mini" style="height:100%">批量导入</el-button>
        </el-upload>
        <!-- 批量修改 -->
        <el-button class="btn" size="mini" type="primary" v-if="isBatch" @click="onBatchEdit">批量修改</el-button>
        <el-dropdown split-button type="primary" @click="handleClick" placement="bottom" v-acl="material_data_synchronization_MDM,material_data_decentralization_MDM">
          接口同步
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <!-- 数据同步MDM -->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_data_synchronization_MDM" type="primary" @click="dataSyncMDM('formal')"> {{$t('material.DataSyncMDM')}}</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!--发送RP&RPF-->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_data_synchronization_MDM" type="primary" @click="senfRpAndRpf('formal')">发送RP&RPF</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!--MDM下发SAP-->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_data_decentralization_MDM" type="primary" @click="toMDM"> {{$t('material.material_data_decentralization_MDM')}}</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown split-button type="primary" @click="handleClick" placement="bottom" v-acl="material_disable,material_data_synchronization_MDM">
          禁用
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <!--RP禁用-->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_disable" type="primary" @click="disableData">RP禁用</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!--RPF禁用-->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_data_synchronization_MDM" type="primary" @click="disabledRpf('disable')">RPF禁用</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!--直送运费禁用-->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_disable" type="primary" @click="disableFreight">直送运费禁用</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown split-button type="primary" @click="handleClick" placement="bottom" v-acl="material_list_download_full_volume,material_historical_version_download">
          报表
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <!--列表下载（全量）-->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_list_download_full_volume" type="primary" @click="download">{{$t('material.material_list_download_full_volume')}}</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!-- 历史版本下载 -->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_historical_version_download" type="primary" @click="downloadHis">{{$t('material.material_historical_version_download')}}</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <!-- 最新版本下载（全量） -->
              <el-button class="dropdownItemBtn" size="mini" v-acl="material_historical_version_download" type="primary" @click="downloadByDc">{{$t('material.downloadAllNew')}}</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 模板更新 -->
        <el-upload v-acl="updateMaterialTemplate" style="margin-right:10px;vertical-align: middle;line-height: 0;" :show-file-list="false" ref="uploadTemplate" :headers="uploadHeader" :action="templateUploadUrl" :on-success="()=>$message.success($t('common.UploadSucceed'))" multiple="false">
          <el-button type="primary" size="mini" style="height:100%">模板更新</el-button>
        </el-upload>
      </el-row>
      <el-table sortable max-height="435" :data="tableData" ref="tableData" row-key="tmMaterialRecordId" @selection-change="handleSelectionChange" border highlight-current-row>
        <el-table-column fixed="left" sortable type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column min-width="80" show-overflow-tooltip　prop="fiveBitCode" label="GRI" fixed="left"></el-table-column>
        <el-table-column min-width="80" show-overflow-tooltip　prop="eightBitCode" :label="$t('material.eightBitCode')" fixed="left"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip　prop="eightBitCodeName" :label="$t('material.eightBitCodeName')" fixed="left">
          <template slot-scope="scope">
            <div class="a-link" @click="goAdd('detail',scope.row.tmMaterialRecordId)">{{scope.row.eightBitCodeName}}</div>
          </template>
        </el-table-column>
        <el-table-column min-width="80" show-overflow-tooltip　prop="dummyCode" :label="$t('material.dummyCode')"></el-table-column>
        <el-table-column min-width="140" show-overflow-tooltip　prop="settlementUnitName" :label="$t('material.settlementUnitName')"></el-table-column>
        <el-table-column min-width="80" show-overflow-tooltip　prop="plantCodeView" label="工厂编码"></el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip　prop="tmPlantName" label="工厂名称"></el-table-column>
        <el-table-column min-width="80" show-overflow-tooltip　prop="statusI18n" :label="$t('material.materialProductStatus')"></el-table-column><!-- 物料产品状态 -->
        <el-table-column min-width="100" show-overflow-tooltip　prop="categoryLevel1Name" label="Category1"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip　prop="categoryLevel2Name" label="Category2"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip　prop="categoryLevel3Name" label="Category3"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip　prop="conductStatusI18n" :label="$t('material.conductStatus')"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip　prop="currentReviewer" :label="$t('fpaManage.permanent.logicStatus')"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip　prop="isSrmIssueI18n" :label="$t('material.isSrmIssue')"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip　prop="isExFactoryPriceIssueI18n" :label="$t('material.isExFactoryPriceIssue')"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip　prop="isInboundFreightIssueI18n" :label="$t('material.isInboundFreightIssue')"></el-table-column>
        <!-- <el-table-column prop="isOutboundFreightIssueI18n" :label="$t('material.isOutboundFreightIssue')"></el-table-column>outbound运费是否下发 -->
        <el-table-column min-width="130" show-overflow-tooltip　prop="isMdmReceiveI18n" :label="$t('material.isMdmReceive')"></el-table-column>
        <el-table-column min-width="110" show-overflow-tooltip　prop="isExFactoryPriceReceiveI18n" :label="$t('material.isExFactoryPriceReceive')"></el-table-column><!-- 物料出厂价是否接收 -->
        <el-table-column min-width="150" show-overflow-tooltip　prop="isMaterialInboundIssueI18n" :label="$t('material.isMaterialInboundIssue')"></el-table-column><!-- 物料outbound 运费是否接收 -->
        <el-table-column min-width="110" show-overflow-tooltip　prop="isStraightFreightIssueI18n" :label="$t('material.isStraightFreightIssueI18n')"></el-table-column><!-- 直送运费是否下发 -->
        <el-table-column min-width="110" show-overflow-tooltip　prop="isFreightReceivedMdmI18n" :label="$t('material.isFreightReceivedMdmI18n')"></el-table-column><!-- 直送运费是否接受 -->
        <!-- <el-table-column prop="isMaterialInboundIssueI18nI18n" :label="$t('material.isMaterialInboundIssueI18n')"></el-table-column> -->
        <el-table-column min-width="110" show-overflow-tooltip　prop="mdmDataReleaseDate" :label="$t('material.mdmDataReleaseDate')"></el-table-column><!-- MDM数据下发日期 -->
        <el-table-column min-width="90" show-overflow-tooltip　prop="fpaBeginEffectiveDate" :label="$t('material.fpaBeginEffectiveDate')"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip　prop="issuePriceTakeEffectDate" :label="$t('material.issuePriceTakeEffectDate')"></el-table-column>
        <!-- 下发价格生效日期->手工指定生效日期 -->
        <el-table-column min-width="100" show-overflow-tooltip　prop="isReceivePriceTouchI18n" :label="$t('material.isReceivePriceTouchI18n')"></el-table-column><!-- 手工指定生效日期是否接受 -->
        <el-table-column min-width="80" show-overflow-tooltip　:label="$t('material.lssueLog')" fixed="right">
          <!-- 下发日志 -->
          <template slot-scope="scope">
            <div class="a-link" @click="getLogPage(scope.row.tmMaterialId)">{{$t('material.see')}}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('material.infoForm')" :visible.sync="showDialog" width="500px">
      <el-form :model="infoForm" ref="infoForm" :rules="rules" :label-position="labelPosition" label-width="140px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('material.issuePriceTakeEffectDate')" prop="issuePriceTakeEffectDate">
              <el-date-picker value-format="yyyy-MM-dd" v-model="infoForm.issuePriceTakeEffectDate" type="date"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" size="mini" @click="showDialog = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" size="mini" @click="confirmToMDM">{{$t('common.submit')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('material.FPARueryPop')" :visible.sync="FPADialog" width="70%">
      <!-- FPA查询弹窗 -->
      <FPADialog ref="FPADialogRef" :fpaStatus="fpaStatus" :multipleSelectionFlag="true" :eightBitCodeList='eightBitCodeList' :tmMaterialRecordId='tmMaterialRecordId' v-if="FPADialogReset" @subCallMethod="selectFPAMethod"></FPADialog>
    </el-dialog>
    <el-dialog :title="$t('material.PricDistributionLog')" :visible.sync="PricDistributionDialog" width="95%">
      <!-- 价格下发日志 -->
      <LogPageDialog :tmMaterialId='tmMaterialId' v-if="PricDistributionDialogReset"></LogPageDialog>
    </el-dialog>
    <el-dialog :visible.sync="ThreeButtonsDialog" width="70%">
      <!-- 三个按钮弹窗 -->
      <el-row type="flex" justify="center">
        <el-button type="primary" size="mini" @click="sendPriceTouch('Last Month')">{{$t('material.IssuedLastMonth')}}</el-button><!-- 下发上个月 -->
        <el-button type="primary" size="mini" @click="sendPriceTouch('This Month')">{{$t('material.IssuedMonth')}}</el-button><!-- 下发当月 -->
        <el-button type="primary" size="mini" @click="sendPriceTouch('Next Month')">{{$t('material.IssuedNextMonth')}}</el-button><!-- 下发下个月 -->
      </el-row>
    </el-dialog>
    <el-dialog :visible.sync="dialogTableVisible" width="40%" :close-on-click-modal="false">
      <dialog-table v-if="dialogTableVisible" :gridData="gridData"></dialog-table>
    </el-dialog>
    <el-dialog :visible.sync="dialogModifyVisible" title="批量修改" width="25%" :close-on-click-modal="false" @close="closeDialog" class="fpa">
      <dialog-modify v-if="dialogModifyVisible" @closeDialog="closeDialog" :materialRecordIdList="materialRecordIdList"></dialog-modify>
    </el-dialog>
    <el-dialog :visible.sync="dialogWithdrawVisible" title="撤回意见" width="30%" :close-on-click-modal="false" @close="closeWithDraw">
      <el-form :model="formData" ref="formData" :rules="formDataRules">
        <el-row type="flex" justify="center">
          <el-col :span="20" :offset="2">
            <el-form-item prop="approvalDescription" style="width:100%" class="is-required">
              <el-input type="textarea" :rows="3" v-model="formData.approvalDescription" />
            </el-form-item>
          </el-col>
        </el-row>
        <div align="center">
          <el-button type="primary" @click="onConfirm">确定</el-button>
          <el-button type="primary" @click="onCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "../../../../api/material/material-master-data";
import { inputChoiceService } from "../../../../api/common/input-choice";
import commonFunction from "../../../../utils/dataTableUtils"
import { Loading, Message } from "element-ui";
import { fileService } from "@/api/common/file-utils";
import FPADialog from '@/components/page/material/material-master-data/FPADialog';
import LogPageDialog from '@/components/page/material/material-master-data/LogPageDialog';
import IcSelect from "@/components/common/icSelect";
import commonFun from "@/utils/commonFun";
import commonConstatns from "@/constants/commonConstants";
import FileUpload from "@/components/common/fileUpload";
import dialogTable from "../../../common/dialogTable.vue";
import dialogModify from "./dialogModify.vue";
import paginationMixin from '@/mixins/pagitionMixin';
import store from '@/store/index'
export default {
  name: 'material-master-data',
  mixins: [paginationMixin],
  components: { FileUpload, FPADialog, LogPageDialog, IcSelect, dialogTable, dialogModify },
  data() {
    return {
      formDataRules: {
        approvalDescription: [
          { required: true, message: '请输入撤回意见', trigger: 'blur' },
        ]
      },
      formData: {
        approvalDescription: "",
      },
      isRecall: false,//撤回权限控制
      isBatch: false,//批量修改权限控制
      dialogWithdrawVisible: false,//撤回弹窗
      dialogTableVisible: false,//批量查询弹窗控制
      dialogModifyVisible: false,//批量修改弹窗
      gridData: [],//批量多选列表
      isShow: false,//控制查询列表收缩展开
      fpaStatus: null,
      eightBitCodeList: [],
      PricDistributionDialog: false,
      ThreeButtonsDialog: false,
      totalCount: 0,
      tableData: [],
      labelPosition: 'right',
      FPADialog: false,
      FPADialogReset: false,
      PricDistributionDialogReset: false,
      FPAForm: {},
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: null,
        eightBitCodeList: [],
        eightBitCodeStr: '',
        eightBitCodeList: null,
        eightBitCodeName: null,
        tmPlantName: null,
        tmPlantCode: null,
        settlementUnitName: null,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        categoryLevel3Id: null,
        status: null,
        conductStatus: null,
        startCreateDate: null,
        endCreateDate: null,
        isUrgentMaterial: null,
        scoped: true
      },
      tmMaterialRecordId: '',
      tmMaterialId: '',
      statusList: [],
      conductStatusList: [],
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      emplFlag: null,
      showDialog: false,
      aterialsAdd: false,
      infoForm: {
        materialRecordIdList: null,//id集合  类型：数组
        issuePriceTakeEffectDate: null,//下发价格生效日期
      },
      rules: {
        issuePriceTakeEffectDate: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
      },
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endCreateDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startCreateDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      loadingInstance: null,
      materialRecordIdList: [],//批量修改传递id
      multipleSelection: [],
    }
  },
  created() {
    // this.queryData(1);
    this.getInputChoiceValues();
    this.getCategoryList(1)
    this.getUserType()
  },
  computed: {
    fileUploadUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `/materialRecord/importData`;
    },
    templateUploadUrl() {
      return commonConstatns.fileUploadUrl + `/materialImportTemplate/1?single=true`;
    }
  },
  mounted() {
    let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
    console.log('ms_Permission', ms_Permission);
    // functioncode material_batch_modification可看到批量修改
    if (ms_Permission.indexOf('material_batch_modification') !== -1) {
      this.isBatch = true
    } else {
      this.isBatch = false
    }
    if (ms_Permission.indexOf('material_recall') !== -1) {
      // functioncode material_recall可看到撤回
      this.isRecall = true
    } else {
      this.isRecall = false
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log("🚀 ~ file: material-master-data.vue ~ line 451 ~ beforeRouteEnter ~ to", to)
    if (to.query.fiveBitCode) {
      to.meta.reqData.fiveBitCode = to.query.fiveBitCode
    }
    apiService.search(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  methods: {
    closeDialog() {
      this.dialogModifyVisible = false
    },
    handleSelectionChange(val) {
      this.materialRecordIdList = []
      this.multipleSelection = val;
      val.forEach(ele => {
        this.materialRecordIdList.push(ele.tmMaterialRecordId)
      })
    },
    onBatchEdit() {
      console.log('this.multipleSelection', this.multipleSelection);
      if (this.multipleSelection.length === 0) {
        this.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
        return false
      }
      var isStatus = this.multipleSelection.every(ele => {
        return ele.conductStatus === 'approved'
      })
      console.log('isStatus', isStatus);
      if (!isStatus) {
        this.$message({ message: '批量修改仅支持审核通过的物料，请检查.', type: "warning" });
        return false
      }
      this.dialogModifyVisible = true
    },
    onWithdraw() {
      console.log('this.multipleSelection', this.multipleSelection);
      if (this.multipleSelection.length === 0) {
        this.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message({ message: "仅支持单个物料撤回，请重新勾选.", type: "warning" });
        return false
      }
      var isStatus = this.multipleSelection.every(ele => {
        return (ele.conductStatus === 'wait_business_review' || ele.conductStatus === 'return' || ele.conductStatus === 'sc_finance_audit') && ele.currentReviewer !== '待HGS预审'
      })
      console.log('isStatus', isStatus);
      if (!isStatus) {
        this.$message({ message: '仅可撤回审核中的物料，请检查.', type: "warning" });
        return false
      }
      this.dialogWithdrawVisible = true
      console.log('materialRecordIdList', this.materialRecordIdList);
    },
    onConfirm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          var obj = {
            tmMaterialRecordId: this.materialRecordIdList[0],
            approvalDescription: this.formData.approvalDescription
          }
          apiService.reCallReq(obj).then(res => {
            console.log('res', res);
            if (res.code === '200') {
              this.$message.success("撤回成功")
              this.$refs.tableData.clearSelection();
              this.queryData()
              this.onCancel()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    onCancel() {
      this.formData.approvalDescription = ''
      this.dialogWithdrawVisible = false
    },
    menuClick() {
      this.gridData = this.queryCondition.eightBitCodeStr;
      this.dialogTableVisible = true;
    },
    beforeUpload() {
      this.loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    uploadSuccess(resp) {
      this.loadingInstance.close();
      if (resp.code == 200) {
        this.$message.success(this.$t("common.UploadSucceed"));
        this.queryData(1);
      } else {
        this.$message.error(resp.msg);
      }
    },
    uploadError(resp) {
      this.loadingInstance.close();
      if (undefined != resp.message) {
        let res = JSON.parse(resp.message);
        this.$message.error(res.msg);
      } else {
        this.$message.error("文件上传失败,请检查后重试！");
      }
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      const eightBitCodeStr = this.queryCondition.eightBitCodeStr
      let eightBitCodeArr = []
      if (eightBitCodeStr && eightBitCodeStr.length > 0) {
        eightBitCodeArr = eightBitCodeStr.replace(/(^\s*)|(\s*$)/g, "").split(/[\n,，\s]+/g);
      }
      this.$set(this.queryCondition, 'eightBitCodeList', eightBitCodeArr)
      apiService.search(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList1 = res.data;
      });
    },
    //数据同步
    dataSyncMDM(status) {
      this.fpaStatus = status;
      let that = this
      let rows = this.$refs.tableData.selection;
      if (rows.length == 0) {
        this.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
      } else {
        for (let a = 0, len = rows.length; a < len; a++) {
          if (rows[a].conductStatusI18n != '审核通过') {
            this.$message({ type: "error", message: this.$t("material.PleaseSelectApproved"), });
            return;
          }
        }
        // var flagArr = []
        // rows.some(function (value, index) {
        //   if (value.categoryLevel2Name == 'POP' || value.categoryLevel2Name == 'Toys' || value.categoryLevel2Name == 'Local Sums ' || value.categoryLevel2Name == 'Local Sums') {
        //     flagArr.push(true)
        //   } else {
        //     flagArr.push(false)
        //   }
        // })
        // if (flagArr.indexOf(true) > -1) {//有pop 玩具 非常规 任意一种
        //   let categoryLevel2NameArr = []
        //   rows.some(function (value, index) {
        //     if (!(value.categoryLevel2Name == 'POP' || value.categoryLevel2Name == 'Toys' || value.categoryLevel2Name == 'Local Sums ' || value.categoryLevel2Name == 'Local Sums')) {
        //       //含有其他种类
        //       categoryLevel2NameArr.push(false)
        //     } else {
        //       categoryLevel2NameArr.push(true)
        //     }
        //   })
        //   if (categoryLevel2NameArr.indexOf(false) > -1) {
        //     that.$message({
        //       message: '请选择相同的数据类型，谢谢',
        //       type: "warning"
        //     });
        //   } else {
        //     //只有 pop 玩具 非常规
        //     that.showDialog = true
        //   }
        // } else {//没有这三种，直接显示FPA
        that.eightBitCodeList = rows.map(v => { return v.eightBitCode })
        console.log(that.eightBitCodeList)
        // that.sonEightBitCode = rows[0].eightBitCode
        that.tmMaterialRecordId = rows.map(v => { return v.tmMaterialRecordId })
        this.FPADialogReset = false
        this.$nextTick(() => {
          this.FPADialogReset = true
        })
        this.FPADialog = true
        // }
      }

    },
    disableFreight() {
      let that = this
      let rows = this.$refs.tableData.selection;
      if (rows.length == 0) {
        that.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
        return
      }
      for (let a = 0, len = rows.length; a < len; a++) {
        if (rows[a].conductStatusI18n != '审核通过') {
          this.$message({ type: "error", message: this.$t("material.PleaseSelectApproved"), });
          return;
        }
      }
      let ids = rows.map(data => data.tmMaterialId)
      apiService.disableFreightBatch(ids).then((res) => {
        if (res.code === '200') {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
          that.queryData();
          that.$refs.tableData.clearSelection();
        } else {
          Message({ message: this.$t('common.operateError'), type: "error" });
        }

      });
    },
    //禁用
    disableData() {
      let that = this
      let rows = this.$refs.tableData.selection;
      console.log('rows', rows);
      if (rows.length == 0) {
        that.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
        return
      }
      for (let a = 0, len = rows.length; a < len; a++) {
        if (rows[a].conductStatusI18n != '审核通过') {
          this.$message({ type: "error", message: this.$t("material.PleaseSelectApproved"), });
          return;
        }
      }
      let ids = rows.map(data => data.tmMaterialRecordId)
      apiService.disableBatch(ids).then((res) => {
        if (res.code === '200') {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
          that.queryData();
          that.$refs.tableData.clearSelection();
        } else {
          Message({ message: this.$t('common.operateError'), type: "error" });
        }

      });
    },
    selectFPAMethod() {
      this.FPADialogReset = false
      this.FPADialog = false;
      this.$nextTick(() => {
        this.FPADialogReset = true
      })
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.queryCondition.categoryLevel3Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList2 = res.data;
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.queryCondition.categoryLevel3Code = null
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 3, pid: this.queryCondition.categoryLevel2Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList3 = res.data;
      });
    },
    async deleteRow() {
      let that = this;
      let rows = this.$refs.tableData.selection;
      if (rows.length == 0) {
        that.$message({
          message: that.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        if (await this.callConfirm()) {
          let ids = rows.map(data => data.tmMaterialRecordId)
          apiService.deleteBatch(ids).then((res) => {
            if (res.code === '200') {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
            that.$refs.tableData.clearSelection();
          });
        }
      }
    },
    //物料信息copy
    async copy() {
      let rows = this.$refs.tableData.selection;
      if (rows.length != 1) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      } else {
        if (rows[0].conductStatus == 'approved') {
          this.goAdd('copy', rows[0].tmMaterialRecordId)
        } else {
          Message.error(this.$t("material.approved"));
        }
      }
    },
    //物料下放MDM->数据同步MDM
    toMDM() {
      let rows = this.$refs.tableData.selection;
      if (rows.length != 1) {
        this.$message({ message: this.$t('common.pleaseSelectOneData'), type: "warning" });
        return;
      } else {
        //是否已同步MDM
        if (rows[0].isExFactoryPriceReceive != 'Y') {
          this.$message({ message: this.$t('material.firstDataSyncMDM'), type: "warning" });//请先将数据同步至MDM
        } else {//三个按钮的弹窗
          this.ThreeButtonsDialog = true
        }
      }
    },
    sendPriceTouch(type) {
      let rows = this.$refs.tableData.selection;
      if (commonFun.isEmpty(rows[0].issuePriceTakeEffectDate)) {
        this.$message({ message: this.$t('material.pleaseIssuePriceTakeEffectDate'), type: "warning" });//请选择手工指定有效期
        return false;
      }
      let data = {
        materialRecordIdList: [rows[0].tmMaterialRecordId],
        feedTimeMdm: type
      }
      console.log(data)
      apiService.sendPriceTouch(data).then((res) => {
        if (res.data) {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
          this.ThreeButtonsDialog = false
          this.queryData();
          that.$refs.tableData.clearSelection();
        } else {
          Message({ message: this.$t('common.operateError'), type: "error" });
        }
      });
    },
    //查询日志
    getLogPage(id) {
      this.tmMaterialId = id
      this.PricDistributionDialog = true
      this.PricDistributionDialogReset = false
      this.$nextTick(() => {
        this.PricDistributionDialogReset = true
      })
    },
    //确定物料下放MDM
    confirmToMDM() {
      let that = this
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          let rows = that.$refs.tableData.selection;
          that.infoForm.materialRecordIdList = rows.map(data => data.tmMaterialRecordId)
          that.infoForm.rpfStatusForMdm = that.fpaStatus;
          apiService.sendMaterialToMDM(this.infoForm, false).then((res) => {
            if (res.data) {
              Message({ message: this.$t('common.operateSuccess'), type: "success" });
              this.showDialog = false
              this.infoForm.issuePriceTakeEffectDate = null
              this.queryData();
              that.$refs.tableData.clearSelection();
            } else {
              Message({ message: this.$t('common.operateError'), type: "error" });
            }
          });
        } else {
          Message({ message: this.$t('material.required'), type: "error" });
          return false;
        }
      })
    },
    disabledRpf(status) {
      this.fpaStatus = status;
      let that = this;
      let rows = that.$refs.tableData.selection;
      if (commonFun.isNotEmpty(rows)) {
        that.infoForm.materialRecordIdList = rows.map(data => data.tmMaterialRecordId);
        that.infoForm.rpfStatusForMdm = that.fpaStatus;
        apiService.checkBatchProductFreightForMaterial(that.infoForm.materialRecordIdList).then(res => {
          console.log("🚀 ~ file: material-master-data.vue:834 ~ apiService.checkBatchProductFreightForMaterial ~ res", res)
          if (res.code === '200') {
            apiService.sendMaterialToMDM(this.infoForm, true).then((res) => {
              if (res.data) {
                Message({ message: this.$t('common.operateSuccess'), type: "success" });
                this.showDialog = false
                this.infoForm.issuePriceTakeEffectDate = null
                this.queryData();
                that.$refs.tableData.clearSelection();
              } else {
                Message({ message: res.msg, type: "error" });
              }
            });
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        that.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
      }
    },
    senfRpAndRpf(status) {
      this.fpaStatus = status;
      let that = this;
      let rows = that.$refs.tableData.selection;
      if (commonFun.isNotEmpty(rows)) {
        that.infoForm.materialRecordIdList = rows.map(data => data.tmMaterialRecordId);
        that.infoForm.rpfStatusForMdm = that.fpaStatus;
        apiService.sendMaterialToMDM(this.infoForm, true).then((res) => {
          if (res.data) {
            Message({ message: this.$t('common.operateSuccess'), type: "success" });
            this.showDialog = false
            this.infoForm.issuePriceTakeEffectDate = null
            this.queryData();
            that.$refs.tableData.clearSelection();
          } else {
            Message({ message: res.msg, type: "error" });
          }
        });
      } else {
        that.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
      }
    },
    //excel下载
    download() {
      apiService.download(this.queryCondition).then((res) => {
        fileService.respToFile(res);
      });
    },
    //历史版本下载
    downloadHis() {
      const eightBitCodeStr = this.queryCondition.eightBitCodeStr
      let eightBitCodeArr = []
      if (eightBitCodeStr && eightBitCodeStr.length > 0) {
        eightBitCodeArr = eightBitCodeStr.replace(/(^\s*)|(\s*$)/g, "").split(/[\n,，\s]+/g);
      }
      this.$set(this.queryCondition, 'eightBitCodeList', eightBitCodeArr)
      let rows = this.$refs.tableData.selection;
      let ids = rows.map(data => data.tmMaterialId)
      this.$set(this.queryCondition, 'materialIdList', ids)
      apiService.downloadHistoricalVersion(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: material-master-data.vue:895 ~ apiService.downloadHistoricalVersion ~ res:", res)
        fileService.respToFile(res);
      });
    },
    //最新版本下载（全量）
    downloadByDc() {
      const eightBitCodeStr = this.queryCondition.eightBitCodeStr
      let eightBitCodeArr = []
      if (eightBitCodeStr && eightBitCodeStr.length > 0) {
        eightBitCodeArr = eightBitCodeStr.replace(/(^\s*)|(\s*$)/g, "").split(/[\n,，\s]+/g);
      }
      this.$set(this.queryCondition, 'eightBitCodeList', eightBitCodeArr)
      apiService.downloadAllBydc(this.queryCondition).then((res) => {
        fileService.respToFile(res);
      });
    },
    downLoadTemplate() {
      fileService.getFileList({ tsReckindId: 'materialImportTemplate', tsRecId: 1 }).then(res => {
        if (commonFun.isEmpty(res)) {
          Message.warning("未找到物料模板！");
        }
        fileService.downloadFile(res[0]);
      });
    },
    //进入新增和详情
    goAdd(type, id, materialType) {
      if (id) {
        this.$router.push({
          path: '/material-master-add',
          query: { id: id, type: type, materialType: materialType }
        });
      } else {
        this.$router.push({
          path: '/material-master-add',
          query: { type: type, materialType: materialType }
        });
      }

    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TM_MATERIAL_RECORD:CONDUCT_STATUS"] = "TM_MATERIAL_RECORD:CONDUCT_STATUS";
      mapObj["TM_MATERIAL:STATUS"] = "TM_MATERIAL:STATUS";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.conductStatusList = res["TM_MATERIAL_RECORD:CONDUCT_STATUS"];
        this.statusList = res["TM_MATERIAL:STATUS"];
      });
    },
    getUserType() {
      //用户所属系统(SUP供应商)
      const emplFlag = localStorage.getItem("ms_emplFlag");
      //供应商用户
      if (emplFlag === 'SUP') {
        this.emplFlag = 'S';
      }
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {//超级管理员
          this.emplFlag = 'M';
        }
        if (permission[i] == 'supplier_newly_build') {//新增
          this.aterialsAdd = true;
        }
      }
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: null,
        eightBitCodeList: [],
        eightBitCodeStr: '',
        eightBitCodeList: null,
        eightBitCodeName: null,
        tmPlantName: null,
        tmPlantCode: null,
        settlementUnitName: null,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        categoryLevel3Id: null,
        status: null,
        conductStatus: null,
        startCreateDate: null,
        endCreateDate: null,
        isUrgentMaterial: null,
        conductStatus: null,
      }
      this.$refs.tableData.clearSelection();
      this.queryData()
    }

  },
  extends: commonFunction
}
</script>
<style scoped lang="scss">
.el-dropdown {
  margin-right: 10px !important;
}
.el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
